<template>
    <div class="g-bottom">
        <div class="bottom-wrapper">
            <div class="flex justify-center m-t-19px"><span class="pointer"><a
                        href="https://www.hellofont.cn/doc?tag=about">关于我们 </a></span>&nbsp;&nbsp;|&nbsp;&nbsp;<span class="pointer"><a
                        href="https://www.hellofont.cn/doc?tag=user-agreement"> 使用须知</a></span></div>
            <div class="flex justify-center m-t-6px">商务合作电话：400 800 2325 版权所有 © 字由HelloFont.com.cn 沪ICP备12022110号-3</div>
            <div class="flex justify-center m-t-2px">沪公网安备 31010902002797号 上海驿创信息技术有限公司</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'g-bottom'
}
</script>

<style lang="less" scoped>
.pointer {
    cursor: pointer;
}

.g-bottom {
    width: 100vw;
    height: 105px;
    position: relative;
    left: 50%;
    transform: translate(-50%);
    background: rgba(51, 52, 54, 1);

    .bottom-wrapper {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(204, 204, 204, 1);
        text-align: left;
        vertical-align: top;
        position: absolute;
        z-index: 10 !important;
        left: 0;
        bottom: 0;
        width: 100vw;
        height: 105px;
        background: rgba(51, 52, 54, 1);
    }
}

.flex {
    display: flex;
}

.justify-center {
    justify-content: center;
}

.m-t-19px {
    margin-top: 19px;
}

.m-t-6px {
    margin-top: 6px;
}

.m-t-2px {
    margin-top: 2px;
}
</style>